import Component from "@glimmer/component";
import { service } from "@ember/service";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import StatusSpinner from "glesys-controlpanel/components/icons/status-spinner";
import { tKey } from "ember-intl";

export const STATE = {
  online: { color: "bg-green-100", labelKey: tKey("label.online") },
  busy: { color: "bg-yellow-200", labelKey: tKey("label.busy") },
  error: { color: "bg-red-400", labelKey: tKey("label.error") },
  offline: { color: "bg-gray-400", labelKey: tKey("label.offline") },
};

export default class StatusIndicator extends Component {
  @service intl;

  get state() {
    return STATE[this.args.status?.state] ?? STATE.offline;
  }

  get colorClass() {
    return this.args.status?.color ?? this.state.color;
  }

  get sizeClass() {
    if (this.args.size === "large") return "size-4";
    if (this.args.size === "small") return "size-2.5";
    return "size-3";
  }

  get showSpinner() {
    return Boolean(this.args.status?.showSpinner);
  }

  get label() {
    let labelKey = this.args.status?.labelKey;
    return labelKey ? this.intl.t(labelKey) : undefined;
  }

  get announcedLabel() {
    return this.label ?? this.intl.t(this.state.labelKey);
  }

  get showLabel() {
    return Boolean(this.args.showLabel) && Boolean(this.announcedLabel);
  }

  <template>
    <span class="inline-flex items-center gap-1.5" {{mergeClasses}} ...attributes>
      {{#if this.showSpinner}}
        <StatusSpinner />
      {{else}}
        <span
          class="{{this.sizeClass}} block rounded-full {{this.colorClass}}"
          role="presentation"
          title={{unless this.showLabel this.announcedLabel}}
        ></span>
      {{/if}}
      <span class={{unless this.showLabel "sr-only"}}>
        {{this.announcedLabel}}
      </span>
    </span>
  </template>
}
